export default __webpack_public_path__ + "static/media/Hero-Picture 7 - without text.644ea8f7.gif";